import { ReminderHours } from '../types/reminder-hours.type';

export interface IReminderInformation {
  reminderTime: ReminderHours;
  isActive:boolean
}

